// extracted by mini-css-extract-plugin
module.exports = {"rtShema":"Shema_rtShema__3-mNi","text":"Shema_text__1oSv_"};